import { FC, useState } from 'react';
import { Button, Col, Popover, Row, Typography } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import UserAvatar, { UserAvatarProps } from 'src/components/UserAvatar';
import { BiTrash } from 'react-icons/bi';

const { Text } = Typography;

interface UserPopoverContentProps {
  user?: any | undefined | null;
  onClose: () => void;
  onRemove?: () => void;
}

const UserPopoverContent: FC<UserPopoverContentProps> = ({ user, onClose, onRemove }) => {
  return (
    <Row
      style={{ maxWidth: 310, columnGap: 12 }}
      wrap={false}
      onClick={(event) => event.stopPropagation()}
    >
      <Col flex="none" style={{ marginTop: 4, marginBottom: 4 }}>
        <UserAvatar user={user} size="xl" />
      </Col>

      <Col flex="auto" className="flex flex-col">
        <Text style={{ paddingRight: 26 }} strong ellipsis>
          {user?.name}
        </Text>

        <Text style={{ fontSize: 12 }} type="secondary">
          {user?.job_title}
        </Text>

        {onRemove && (
          <div className='flex items-center justify-end'>
            <Button
              type="link"
              size="small"
              danger
              style={{ padding: 0, marginTop: 4, textAlign: 'left' }}
              onClick={() => {
                onRemove();
                onClose();
              }}
            >
              <BiTrash size={18} />
            </Button>
          </div>
        )}
      </Col>

      <div style={{ position: 'absolute', top: 2, right: 2 }}>
        <Button
          type="link"
          size="middle"
          icon={<CloseOutlined className="text-gray-400" />}
          onClick={onClose}
        />
      </div>
    </Row>
  );
};

interface UserAvatarPopoverProps extends UserAvatarProps {
  editable?: boolean;
  onRemove?: () => void;
}

const UserAvatarPopover: FC<UserAvatarPopoverProps> = ({ user, size, shape = 'square', onRemove, editable }) => {
  const [open, setOpen] = useState(false);
  const [trigger, setTrigger] = useState<'hover' | 'click'>('hover');

  return (
    <Popover
      open={open}
      trigger={trigger}
      placement="topLeft"
      content={
        <UserPopoverContent
          user={user}
          onRemove={editable ? onRemove : undefined}
          onClose={() => {
            if (trigger !== 'hover') {
              setTrigger('hover');
            }
            setOpen(false);
          }}
        />
      }
      onOpenChange={(newOpen) => {
        if (!newOpen && trigger !== 'hover') {
          setTrigger('hover');
        }
        setOpen(newOpen);
      }}
      destroyTooltipOnHide
    >
      <div
        style={{ display: 'inline-block' }}
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          setTrigger('click');
        }}
      >
        <UserAvatar user={user} size={size} style={{ cursor: 'pointer' }} shape={shape} />
      </div>
    </Popover>
  );
};

export default UserAvatarPopover;
